import { routeNames } from '@app/router';

export default () => [
    {
        label: 'about us',
        path: 'about-us',
        type: 'static'
    },
    {
        label: 'careers',
        path: 'careers-',
        type: 'static'
    },
    {
        label: 'cooperation',
        path: 'cooperation-',
        type: 'static'
    },
    {
        label: 'agencies',
        routeName: routeNames.shops,
        type: 'route'
    },
    {
        label: 'help',
        path: 'help-url',
        type: 'static'
    },
    {
        label: 'cookies',
        path: 'cookies-',
        type: 'static'
    },
    {
        label: 'responsible gaming',
        path: 'responsible-gaming',
        type: 'static'
    },
    {
        label: 'ABC player',
        path: 'abc-player',
        type: 'static'
    },
    {
        label: 'payment methods',
        path: 'payment-methods',
        type: 'static'
    },
    {
        label: 'Terms and Conditions',
        path: 'terms-and-conditions',
        type: 'static'
    },
];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/terminal/poland/app/modules/layout/footer/components/AboutSuperbetLinks.ts